import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import ImageSelector from '../../../components/ImageSelectorFeatured'
import { InputField } from '../../../components/InputField'
import { ENDPOINT, Routes } from '../../../constants'
import { useAuth } from '../../../contexts/AuthContext'
import { FeaturedProps } from '../../../types/featured'
import { useApi } from '../../../contexts/ApiContext'
import { FetchApi } from '../../../api/fetch'

function ManageFeatured() {
   const { state } = useLocation<FeaturedProps>()
   const { push } = useHistory()

   const [featured, setFeatured] = useState<FeaturedProps | any>(state)
   const [featuredThumbnail, setFeaturedThumbnail] = useState<string>(String)
   const [featuredName, setFeaturedName] = useState('')
   const [featuredFile, setFeaturedFile] = useState()


   const { setIsLoadingOverlayDisplay, getUserJWT } = useAuth()
   const { uploadFile } = useApi()


   const onSelectFeaturedThumbnail = () => {
      setTimeout(() => {
         document?.getElementById("featuredThumbnailSelector")?.click()
      }, 0)
   }

   const handleFeaturedThumbnailSelected = (event: any) => {
      const reader = new FileReader()
      const file = event?.target?.files && event?.target?.files[0]

      if (file) {
         setFeaturedFile(file)
         reader.onloadend = () => {
            setFeaturedThumbnail(reader?.result as string)
            setFeaturedName(
               file.name
               // `thumbnail.${extension(file.type)}`
            )
         }
         reader.readAsDataURL(file as Blob)
      }
   }

   const handleChange = (e: any) => {
      const { target } = e;

      setFeatured({ ...featured, [target.name]: target.value })

   }


   const saveFeatured = async (e: any) => {
      e.preventDefault()

      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      if (featuredFile) {
         await uploadFile(
            featuredFile,
         )

      }
      const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"
      const thumbnailUrl = Boolean(featuredThumbnail) ? `${urlBase}/${featuredName}` : state.thumbnailUrl
      if (state?.id !== undefined) {
         try {
          await FetchApi({
               endpoint: `${ENDPOINT.BASE_ENDPOINT}/featured_project/${state?.id}`,
               method: "PATCH",
               JWT: userJWT,
               body:  ({ ...featured, thumbnailUrl, position: 1 })
            })

       push(Routes.FEATURED_COLLECTION)
  
         } catch (error) {
            console.log('something went wrong');
         }
      } else {
         try {
            await FetchApi({
               endpoint: `${ENDPOINT.BASE_ENDPOINT}/featured_project`,
               method: "POST",
               JWT: userJWT,
               body:  ({ ...featured, thumbnailUrl, position: 1 })
            })

            push(Routes.FEATURED_COLLECTION)
         } catch (error) {
            console.log('something went wrong', error);
         }
      }

      setIsLoadingOverlayDisplay(false)
   }

   return (
      <div className='w-11/12 m-auto my-10'>
         <div className="mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-3xl text-left">
               {state?.id ? 'Edit' : 'Create New'} Featured Project
            </h1>
         </div>
         <form onSubmit={saveFeatured}>
            <div className="flex gap-12 mb-8">
               <div className="w-6/12">
                  <InputField
                     label="Featured Name"
                     name='name'
                     defaultValue={state?.name}
                     onChange={handleChange}
                     required
                  />
                  <div className="mb-4">
                     <label className="inline-block text-sm font-base text-gray-40 mb-2 w-5/6 mr-0">
                        Project Description
                     </label>
                     <textarea
                        rows={6} id=""
                        className="block bg-transparent border-2 border-kyzzen-secondary rounded-lg w-full"
                        name='description'
                        defaultValue={state?.description}
                        onChange={handleChange}
                        required
                     />

                  </div>
                  <InputField
                     label="URL"
                     name='projectUrl'
                     type='url'
                     defaultValue={state?.projectUrl}
                     onChange={handleChange}
                     required
                  />
               </div>
               <div className="w-6/12">
                  <input
                     style={{ display: "none" }}
                     type="file"
                     accept=".png, .jpg, .jpeg, .gif"
                     id="featuredThumbnailSelector"
                     onChange={handleFeaturedThumbnailSelected}
                  />
                  <ImageSelector
                     iconSrc={Boolean(featuredThumbnail) ? featuredThumbnail : state?.thumbnailUrl ? state?.thumbnailUrl : ''}
                     onSelectIcon={onSelectFeaturedThumbnail}
                  />
               </div>
            </div>
            <div>
               <button type="submit" className="btn w-full border-gradient ">Save</button>
            </div>
         </form>
      </div>
   )
}

export default ManageFeatured